import { forwardRef } from 'react';

import MultiverseLogoSvgV2 from '@/public/images/logo-v2.svg';
import MultiverseLogoSvg from '@/public/images/logo.svg';

import type { SVGProps } from 'react';

interface MultiverseLogoProps extends SVGProps<SVGElement> {
  theme?: string;
  navFill?: boolean;
  className?: string;
  isV2?: boolean;
}
// eslint-disable-next-line react/display-name
const MultiverseLogo = forwardRef(
  ({ theme, navFill, className, isV2, ...props }: MultiverseLogoProps, ref) => {
    const SvgComponent = isV2 ? MultiverseLogoSvgV2 : MultiverseLogoSvg;

    const color =
      navFill || theme === 'dark'
        ? 'var(--colour-deep-space)'
        : 'var(--colour-white)';
    return (
      <SvgComponent
        className={className}
        fill={color}
        aria-hidden="true"
        ref={ref}
        {...props}
      />
    );
  },
);

export { MultiverseLogo };
